export class SelectOption {
  constructor(public value: string, public text: string) {}

  patientTrialId?: string;

  /**
   * Renders the option as unselectable. AB#34841. Optional and undefined by default, so the
   * eleven existing usages of app-input-multi-select are unaffected.
   */
  disabled?: boolean;
}
